import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AddressInfoCardComponent } from "../../../../../../common/address-info-card/address-info-card.component";
import { ContactInfoCardComponent } from "../../../../../../common/contact-info-card/contact-info-card.component";
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { AccountModel } from "../../../../../../domain/models/account.model";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { EnrollmentOwnerComponent } from "../../../../../../common/enrollment-owner/enrollment-owner.component";
import { CustomerFormComponent } from "../customer-form-component";
import { Icons } from "../../../../../../domain/enums/icons-enums";
import { StatusIndicatorComponent } from "../../../../../../common/status-indicator/status-indicator.component";
import { CurrencyInputDirective } from "../../../../../../utils/directives/currency-input.directive";
import {FormValidationUtil} from "../../../../../../utils/form-validation.util";

@Component({
  selector: 'app-profile-tab',
  standalone: true,
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    FormsModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    ReactiveFormsModule,
    MatDividerModule,
    CommonModule,
    MatDivider,
    MatRadioModule,
    AddressInfoCardComponent,
    ContactInfoCardComponent,
    EnrollmentOwnerComponent,
    StatusIndicatorComponent,
    CurrencyInputDirective
  ],
  templateUrl: './profile-tab.component.html',
  styleUrl: './profile-tab.component.css'
})
export class ProfileTabComponent implements OnInit, CustomerFormComponent, OnChanges {
  @Input() account!: AccountModel;
  @ViewChild(AddressInfoCardComponent) addressInfo!: AddressInfoCardComponent;
  otherInfoForm!: FormGroup;
  contactInfoForm!: FormGroup;
  protected readonly icons = Icons;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.buildForm(this.account);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buildForm(this.account);
    console.log(this.account)
  }

  buildForm(info: AccountModel): void {
    this.contactInfoForm = this.fb.group({
      firstName: [info?.firstName ?? '', Validators.required],
      lastName: [info?.lastName ?? '', Validators.required],
      email: [info?.email ?? '', [Validators.required, Validators.email]],
      phone: [info?.phoneNumber ?? '', [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]]
    });
    this.otherInfoForm = this.fb.group({
      status: [info?.status ?? '', Validators.required],
      billingFreq: [info?.frequency, Validators.required],
      credit: [info?.credit ?? 0, [Validators.required,
        Validators.pattern(FormValidationUtil.getCurrencyValidationPattern())]],
    });

  }

  private getContactInfoValue(): Partial<AccountModel> {
    const formData = this.contactInfoForm.value;
    return {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phoneNumber: formData.phone
    }
  }

  private getOtherInfoValue(): Partial<AccountModel> {
    const formData = this.otherInfoForm.value;
    return {
      status: formData.status,
      frequency: formData.billingFreq,
      credit: formData.credit
    }
  }

  getUpdatedAccount(): AccountModel {
    return {
      ...this.account,
      ...this.addressInfo.getAddressInfoFromForm(),
      ...this.getOtherInfoValue(),
      ...this.getContactInfoValue(),
    };
  }

  isFormValid(): boolean {
    return this.otherInfoForm.valid &&
      this.contactInfoForm.valid &&
      this.addressInfo.isFormValid();
  }

  raiseFormValidations(): void {
    this.otherInfoForm.markAllAsTouched();
    this.contactInfoForm.markAllAsTouched();
    this.addressInfo.raiseFormValidations();
  }

}
